import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import {
  ArrowLeft, Copy, Loader2, RotateCcw, CheckCircle2, ExternalLink, Mail, Send,
} from "lucide-react";

// ── Logos
const LinkedInLogo = () => (
  <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
);
const WhatsAppLogo = () => (
  <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/></svg>
);
const FacebookLogo = () => (
  <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
);
const InstagramLogo = () => (
  <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor"><path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"/></svg>
);
const EmailIcon = () => <Mail className="w-6 h-6" strokeWidth={1.8} />;

const CHANNELS = [
  { id: "email",     label: "Email",     logo: EmailIcon,     color: "#00DC82" },
  { id: "linkedin",  label: "LinkedIn",  logo: LinkedInLogo,  color: "#0A66C2" },
  { id: "whatsapp",  label: "WhatsApp",  logo: WhatsAppLogo,  color: "#25D366" },
  { id: "facebook",  label: "Facebook",  logo: FacebookLogo,  color: "#1877F2" },
  { id: "instagram", label: "Instagram", logo: InstagramLogo, color: "#E4405F" },
];

export default function SocialMode() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [p, setP] = useState(null);
  const [channel, setChannel] = useState("email");
  const [messages, setMessages] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/prospects/${id}`);
        setP(data.prospect);
      } catch { toast.error("Prospect introuvable"); }
    })();
  }, [id]);

  const generate = async () => {
    if (!p) return;
    setLoading(true);
    try {
      // Backend accepts "prospect" as the canonical key (with "lead" backward-compat)
      const { data } = await api.post("/ai/social-messages", { prospect: p, channel });
      setMessages(data);
    } catch { toast.error("Service indisponible"); }
    finally { setLoading(false); }
  };

  useEffect(() => { setMessages(null); generate(); /* eslint-disable-next-line */ }, [p, channel]);

  const copy = (t) => { navigator.clipboard.writeText(t); toast.success("Copié dans le presse-papiers"); };

  const markSent = async () => {
    try {
      await api.post("/interactions", { prospect_id: id, type: channel, notes: `Message ${channel} envoyé` });
      await api.put(`/prospects/${id}`, { status: "Contacté" });
      toast.success("Marqué comme envoyé");
      navigate(`/prospect/${id}`);
    } catch { toast.error("Erreur enregistrement"); }
  };

  const openEmailClient = () => {
    if (!p?.email || !messages?.subject || !messages?.body) {
      toast.error("Email du prospect ou message manquant");
      return;
    }
    const url = `mailto:${p.email}?subject=${encodeURIComponent(messages.subject)}&body=${encodeURIComponent(messages.body)}`;
    window.location.href = url;
  };

  const openWhatsApp = () => {
    const phone = (p?.phone || "").replace(/\s/g, "").replace(/^\+/, "");
    if (!phone) { toast.error("Numéro WhatsApp manquant"); return; }
    if (!messages?.message) { toast.error("Message manquant"); return; }
    window.open(`https://wa.me/${phone}?text=${encodeURIComponent(messages.message)}`, "_blank", "noopener,noreferrer");
  };

  const openLinkedIn = () => {
    const url = p?.linkedin_url || "";
    if (url) {
      window.open(url.startsWith("http") ? url : `https://${url}`, "_blank", "noopener,noreferrer");
    } else {
      window.open(`https://www.linkedin.com/search/results/people/?keywords=${encodeURIComponent(p?.name || p?.company || "")}`, "_blank", "noopener,noreferrer");
    }
  };

  if (!p) return (
    <div className="min-h-screen grid place-items-center bg-[var(--bg)]">
      <div className="w-8 h-8 rounded-full border-2 border-emerald-500 border-t-transparent animate-spin" />
    </div>
  );

  return (
    <div className="min-h-screen bg-[var(--bg)] text-[var(--text)] pb-32">
      {/* Sticky header */}
      <div className="sticky top-0 z-10 bg-[rgba(9,9,11,0.85)] backdrop-blur-md border-b border-[var(--border)]">
        <div className="max-w-2xl mx-auto px-4 py-3 flex items-center gap-3">
          <button onClick={() => navigate(-1)} className="w-9 h-9 rounded-lg border border-[var(--border)] grid place-items-center text-zinc-300 hover:border-zinc-700 transition-colors">
            <ArrowLeft className="w-4 h-4" />
          </button>
          <div className="flex-1 min-w-0">
            <div className="font-display font-semibold text-base text-[var(--text)] truncate">{p.name || "Prospect"}</div>
            <div className="text-xs text-zinc-500 truncate">{p.company || "—"}</div>
          </div>
          <button
            onClick={generate}
            disabled={loading}
            data-testid="regenerate-msg"
            className="hp-btn hp-btn-secondary h-9 px-3 text-xs disabled:opacity-50"
          >
            {loading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <RotateCcw className="w-3.5 h-3.5" />}
            <span className="hidden sm:inline">Régénérer</span>
          </button>
        </div>
      </div>

      <div className="max-w-2xl mx-auto px-4 mt-4 space-y-4">
        {/* Channel picker — horizontal scroll on mobile */}
        <div className="flex gap-2 overflow-x-auto -mx-1 px-1 pb-1 no-scrollbar" data-testid="channel-picker">
          {CHANNELS.map((c) => {
            const Logo = c.logo;
            const isActive = channel === c.id;
            return (
              <button
                key={c.id}
                onClick={() => setChannel(c.id)}
                data-testid={`channel-${c.id}`}
                className={`shrink-0 rounded-xl px-4 py-3 border transition-colors flex items-center gap-2.5 min-w-[120px] ${
                  isActive
                    ? "bg-[var(--surface)] text-[var(--text)]"
                    : "bg-[var(--surface)] text-zinc-400 border-[var(--border)] hover:border-zinc-700"
                }`}
                style={isActive ? { borderColor: c.color, boxShadow: `0 0 0 1px ${c.color}` } : {}}
              >
                <span style={{ color: isActive ? c.color : undefined }}>
                  <Logo />
                </span>
                <span className="text-sm font-semibold">{c.label}</span>
              </button>
            );
          })}
        </div>

        {/* Loading */}
        {loading && (
          <div className="grid place-items-center py-12">
            <Loader2 className="w-6 h-6 text-emerald-400 animate-spin" />
            <div className="text-xs text-zinc-500 mt-2">Prosperr rédige vos messages…</div>
          </div>
        )}

        {/* Messages */}
        {!loading && messages && (
          <div className="space-y-3">
            {/* Email */}
            {channel === "email" && (
              <>
                <EmailCard subject={messages.subject} body={messages.body} onCopy={copy} />
                <MsgCard label="Relance · J+3" body={messages.relance_j3} onCopy={copy} testId="msg-relance-j3" />
                <MsgCard label="Relance finale · J+10" body={messages.relance_j10} onCopy={copy} testId="msg-relance-j10" />
                <button
                  onClick={openEmailClient}
                  disabled={!p.email || !messages.subject}
                  data-testid="open-email-client"
                  className="hp-btn hp-btn-primary w-full h-12 text-sm disabled:opacity-50"
                >
                  <Send className="w-4 h-4" />
                  {p.email ? "Ouvrir dans mon client mail" : "Email du prospect manquant"}
                </button>
              </>
            )}

            {/* LinkedIn */}
            {channel === "linkedin" && (
              <>
                <MsgCard label="Demande de connexion" body={messages.connection} onCopy={copy} maxChars={300} testId="msg-connection" />
                <MsgCard label="Premier message après acceptation" body={messages.first} onCopy={copy} testId="msg-first" />
                <MsgCard label="Relance · J+5" body={messages.relance_j5} onCopy={copy} testId="msg-relance-j5" />
                <MsgCard label="Relance finale · J+12" body={messages.relance_j12} onCopy={copy} testId="msg-relance-j12" />
                <button onClick={openLinkedIn} className="hp-btn hp-btn-primary w-full h-12 text-sm" data-testid="open-linkedin">
                  <ExternalLink className="w-4 h-4" />
                  Ouvrir le profil LinkedIn
                </button>
              </>
            )}

            {/* WhatsApp */}
            {channel === "whatsapp" && (
              <>
                <MsgCard label="Message WhatsApp" body={messages.message} onCopy={copy} maxChars={400} testId="msg-whatsapp" />
                <MsgCard label="Script vocal · 30 secondes" body={messages.voice_script} onCopy={copy} testId="msg-voice" />
                <MsgCard label="Relance · J+2" body={messages.relance_j2} onCopy={copy} testId="msg-relance-j2" />
                <button onClick={openWhatsApp} disabled={!p.phone} className="hp-btn hp-btn-primary w-full h-12 text-sm disabled:opacity-50" data-testid="open-whatsapp">
                  <ExternalLink className="w-4 h-4" />
                  {p.phone ? "Ouvrir WhatsApp" : "Téléphone du prospect manquant"}
                </button>
              </>
            )}

            {/* Facebook / Instagram */}
            {(channel === "facebook" || channel === "instagram") && (
              <>
                <MsgCard label="Message direct" body={messages.message} onCopy={copy} maxChars={500} testId="msg-direct" />
                {messages.voice_script && <MsgCard label="Script audio" body={messages.voice_script} onCopy={copy} />}
                {messages.relance_j2 && <MsgCard label="Relance · J+2" body={messages.relance_j2} onCopy={copy} />}
              </>
            )}
          </div>
        )}
      </div>

      {/* Sticky footer — Mark as sent */}
      {!loading && messages && (
        <div className="fixed bottom-0 left-0 right-0 z-20 bg-[rgba(9,9,11,0.92)] backdrop-blur-md border-t border-[var(--border)] px-4 py-3">
          <div className="max-w-2xl mx-auto">
            <button
              onClick={markSent}
              data-testid="mark-sent"
              className="w-full rounded-lg border border-emerald-500/40 bg-emerald-500/10 hover:bg-emerald-500/20 text-emerald-300 h-12 text-sm font-semibold transition-colors flex items-center justify-center gap-2"
            >
              <CheckCircle2 className="w-4 h-4" /> Marquer comme envoyé
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Email card with subject + body
function EmailCard({ subject, body, onCopy }) {
  if (!subject && !body) return null;
  return (
    <div className="hp-card overflow-hidden" data-testid="email-card">
      <div className="px-4 py-3 border-b border-[var(--border-soft)] bg-[var(--surface-alt)]/40">
        <div className="hp-label">Objet de l'email</div>
        <div className="flex items-center justify-between gap-2 mt-1">
          <div className="text-sm font-medium text-[var(--text)] flex-1 truncate" data-testid="email-subject">{subject || "—"}</div>
          {subject && (
            <button onClick={() => onCopy(subject)} className="text-[11px] font-semibold text-emerald-400 hover:text-emerald-300 flex items-center gap-1 shrink-0">
              <Copy className="w-3 h-3" /> Copier
            </button>
          )}
        </div>
      </div>
      <div className="p-4">
        <div className="flex items-center justify-between gap-2 mb-2">
          <div className="hp-label">Corps de l'email</div>
          {body && (
            <button onClick={() => onCopy(body)} className="text-[11px] font-semibold text-emerald-400 hover:text-emerald-300 flex items-center gap-1">
              <Copy className="w-3 h-3" /> Copier
            </button>
          )}
        </div>
        <div className="text-sm text-zinc-200 leading-relaxed whitespace-pre-wrap" data-testid="email-body">{body || "—"}</div>
        {body && (
          <div className="text-[11px] text-zinc-500 text-right tabular-nums mt-2">{body.length} caractères · ~{Math.round(body.split(/\s+/).length)} mots</div>
        )}
      </div>
    </div>
  );
}

// ── Generic message card
function MsgCard({ label, body, onCopy, maxChars, testId }) {
  if (!body) return null;
  const len = body.length;
  const overflow = maxChars && len > maxChars;
  return (
    <div className="hp-card p-4">
      <div className="flex items-center justify-between gap-2 mb-2">
        <div className="hp-label">{label}</div>
        <button onClick={() => onCopy(body)} className="text-[11px] font-semibold text-emerald-400 hover:text-emerald-300 flex items-center gap-1">
          <Copy className="w-3 h-3" /> Copier
        </button>
      </div>
      <div className="text-sm text-zinc-200 leading-relaxed whitespace-pre-wrap" data-testid={testId}>{body}</div>
      {maxChars && (
        <div className={`text-[11px] tabular-nums text-right mt-2 ${overflow ? "text-rose-400 font-semibold" : "text-zinc-500"}`}>
          {len} / {maxChars} caractères
        </div>
      )}
    </div>
  );
}
